import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from 'react-router-dom'
import styled, { useTheme } from 'styled-components'

import { FlexRow } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { mixpanel } from '@/mixpanel'

import type { FC } from 'react'
import type { HomeShortcut } from '@/modules/home/hooks/useGetHomeShortcuts'

type Props = {
  shortcutItem: HomeShortcut
}

export const ShortcutCard: FC<Props> = ({ shortcutItem }) => {
  const theme = useTheme()
  const navigate = useNavigate()

  const handleClick = () => {
    if (shortcutItem.onClick) {
      shortcutItem.onClick()

      return
    }

    if (shortcutItem.link) {
      mixpanel.track(`home_shortcut_${shortcutItem.title.toLowerCase()}`)
      navigate(shortcutItem.link)
    }
  }
  return (
    <StCard onClick={handleClick}>
      <FontAwesomeIcon
        icon={shortcutItem.icon}
        color={theme.Colors.Theme.Secondary}
        style={{
          alignSelf: 'start',
          fontSize: '1.25rem',
        }}
      />

      <StCardContent>
        <Span type='BodyLargeRegular' style={{ lineHeight: '18px' }}>
          {shortcutItem.title}
        </Span>

        <StIconContainer>
          <FontAwesomeIcon icon={shortcutItem.onClick ? ['fal', 'external-link'] : ['far', 'chevron-right']} />
        </StIconContainer>
      </StCardContent>
    </StCard>
  )
}

const StCard = styled.div`
  background-color: ${({ theme }) => theme.Components.Card.Fill};
  border: 1px solid ${({ theme }) => theme.Components.Card.Border};
  border-radius: ${({ theme }) => theme.UI.BorderRadius.Large}px;

  color: ${({ theme }) => theme.Components.Card.Text};

  padding: ${({ theme }) => theme.UI.SpacingPx.Space4};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.UI.SpacingPx.Space4};
  min-width: 150px;
`

const StIconContainer = styled(FlexRow)`
  flex: 1;
  justify-content: flex-end;
`

const StCardContent = styled(FlexRow)`
  max-width: 100%;
  justify-content: space-between;
  align-items: flex-end;
  flex: 1;

  span {
    display: block;
    white-space: pre-line;
    font-weight: 400;
    flex: 2;
  }
`
